import { LogManager } from '../../../common/port/log/log.manager.port';
import { AccountMetricsInsightsDigitalIntensitySummaryEntityMapper } from '../../../infrastructure/mappers/challenge-insights/account-metrics-insights-digital-intensity-summary.entity.mapper';
import { GetAccountMetricsInsightsDigitalIntensitySummaryRequestDto } from '../../dtos/challenge-insights/get-account-metrics-insights-digital-intensity-summary.request.dto';
import { GetAccountMetricsInsightsDigitalIntensitySummaryResponseDto } from '../../dtos/challenge-insights/get-account-metrics-insights-digital-intensity-summary.response.dto';
import { GetAccountMetricsInsightsDigitalIntensitySummaryQuery } from '../../queries/challenge-insights/get-account-metrics-insights-digital-intensity-summary.query';

export class GetAccountMetricsInsightsDigitalIntensitySummaryController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAccountMetricsInsightsDigitalIntensitySummaryQuery,
    protected readonly mapper: AccountMetricsInsightsDigitalIntensitySummaryEntityMapper
  ) {}

  async get(
    props: GetAccountMetricsInsightsDigitalIntensitySummaryRequestDto
  ): Promise<GetAccountMetricsInsightsDigitalIntensitySummaryResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `GetAccountMetricsInsightsDigitalIntensitySummaryController.get encountered an error ${error}`
      );
    }
  }
}
